import { render, staticRenderFns } from "./AllPlacesModal.vue?vue&type=template&id=0be8bcfd"
import script from "./AllPlacesModal.vue?vue&type=script&lang=ts"
export * from "./AllPlacesModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports